import type { Article } from 'types/capi/article';

import ArticleV2 from '~/components/article/ArticleV2';
import usePageData from '~/hooks/usePageData';
import seo from '~/utils/seo';

import ArticleV1Component from './legacy-article/ArticleV1';

export default function NewsRoute() {
  const data = usePageData<Article>();

  return data.template === 'v2' ? <ArticleV2 /> : <ArticleV1Component />;
}

type LoaderData = {
  pageData: Article;
};

export const meta = ({ data }: { data?: LoaderData }) => {
  return data
    ? seo.formatForMeta(data.pageData.canonical_url, data.pageData.seo)
    : [];
};

export { loader } from './legacy-article/loader.server';
